import { Box, Button, List, ListItem, Typography } from '@mui/material'
import { DailyOrderType } from 'constant'
import { OrderContext } from 'contexts/OrderContextProvider'
import useDailyOrder from 'hooks/useDailyOrder'
import { useContext, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

const SpecialOrder = () => {
  const navigate = useNavigate()
  const { company } = useParams()
  const {
    dailyOrders,
    handleFetchDailyOrders,
    setSelectedDailyOrderClass,
    filteredDailyOrdersByClass,
    selectedDailyOrderBatchIndex,
    setSelectedDailyOrderBatchIndex
  } = useContext(OrderContext)
  const { getDailyOrderBackColor, calculateOrdersLeft } = useDailyOrder()
  const batchSize = 20

  const getBatches = (orders: any[], batchSize: number) => {
    const batches = []
    for (let i = 0; i < orders.length; i += batchSize) {
      batches.push(orders.slice(i, i + batchSize))
    }
    return batches
  }

  useEffect(() => {
    handleFetchDailyOrders(`${company}`, DailyOrderType.SpecialOrder)
  }, [])

  return filteredDailyOrdersByClass.length > 0 ? (
    <Box>
      <Box sx={{ margin: '20px', position: 'relative' }}>
        <Button
          variant='outlined'
          onClick={() => {
            setSelectedDailyOrderClass(undefined)
            setSelectedDailyOrderBatchIndex(undefined)
          }}
          sx={{
            position: 'absolute'
          }}
        >
          Back to last step
        </Button>
        <Typography variant='h5' sx={{ fontWeight: 600, textAlign: 'center' }}>
          {calculateOrdersLeft(filteredDailyOrdersByClass)} special orders left
        </Typography>
      </Box>
      <List>
        {getBatches(filteredDailyOrdersByClass, batchSize).map(
          (batch, index) => (
            <ListItem key={index}>
              <Button
                variant='contained'
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  textTransform: 'none',
                  fontSize: '20px',
                  backgroundColor: '#5a7690'
                }}
                onClick={() => {
                  if (selectedDailyOrderBatchIndex === index) {
                    setSelectedDailyOrderBatchIndex(undefined)
                  } else {
                    setSelectedDailyOrderBatchIndex(index)
                  }
                }}
              >
                {`${index * batchSize + 1}-${Math.min((index + 1) * batchSize, filteredDailyOrdersByClass.length)}`}
              </Button>
            </ListItem>
          )
        )}
      </List>
      {selectedDailyOrderBatchIndex !== undefined && (
        <Box sx={{ padding: '20px' }}>
          {getBatches(filteredDailyOrdersByClass!, batchSize)[
            selectedDailyOrderBatchIndex
          ].map((order, idx) => (
            <Button
              key={order._id || idx}
              fullWidth
              variant='outlined'
              onClick={() =>
                navigate(`/${company}/daily-order/${order.orderNumber}`)
              }
              sx={{
                display: 'block',
                marginBottom: '20px',
                padding: '10px',
                border: '1px solid #ccc',
                fontSize: '36px',
                color: '#000000',
                backgroundColor: getDailyOrderBackColor(order)
              }}
            >
              Order: {order.orderNumber} Bin: {order.orderItems[0].bin}
            </Button>
          ))}
        </Box>
      )}
    </Box>
  ) : (
    <Box>
      <Button
        variant='outlined'
        onClick={() => {
          navigate(-1)
        }}
        sx={{
          margin: '20px'
        }}
      >
        Back
      </Button>
      {dailyOrders.length > 0 ? (
        <List
          sx={{
            '& .MuiListItemButton-root': {
              color: '#607998',
              fontFamily: 'sans-serif',
              fontWeight: 600
            },
            '& a': {
              textDecoration: 'none'
            }
          }}
        >
          {dailyOrders.map(order => (
            <Box key={order.class}>
              <ListItem>
                <Button
                  variant='contained'
                  sx={{
                    width: '100%',
                    textAlign: 'center',
                    textTransform: 'none',
                    fontSize: '26px',
                    padding: '50px 20px',
                    backgroundColor: '#364c63',
                    marginBottom: '20px'
                  }}
                  onClick={() => {
                    setSelectedDailyOrderClass(order.class)
                  }}
                >
                  {order.class}
                </Button>
              </ListItem>
            </Box>
          ))}
        </List>
      ) : (
        <Typography variant='h3' textAlign='center' marginTop='30px'>
          No special orders found!
        </Typography>
      )}
    </Box>
  )
}

export default SpecialOrder
